import { render, staticRenderFns } from "./ordercount.vue?vue&type=template&id=4ef21b84&scoped=true"
import script from "./ordercount.vue?vue&type=script&lang=js"
export * from "./ordercount.vue?vue&type=script&lang=js"
import style0 from "./ordercount.vue?vue&type=style&index=0&id=4ef21b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef21b84",
  null
  
)

export default component.exports